module.exports = __webpack_public_path__ + "img/MobileViewLogo-min.0a47775.png";